import React from 'react';

const CURRENCY_SYMBOLS = {
  USD: '$', EUR: '€', GBP: '£', BBD: 'BBD$',
};

/**
 * CurrencyAmount — renders a value in cents (or dollars) with the
 * correct currency prefix. Accepts either `cents` or `value` (dollars).
 * Falls back to em-dash for missing values.
 */
function CurrencyAmount({ cents, value, currency = 'BBD', decimals = 2, className }) {
  let numeric = null;
  if (cents != null && cents !== '' && !Number.isNaN(Number(cents))) numeric = Number(cents) / 100;
  else if (value != null && value !== '' && !Number.isNaN(Number(value))) numeric = Number(value);

  if (numeric == null) return <span className={className}>—</span>;

  const symbol = CURRENCY_SYMBOLS[currency] || '';
  const formatted = numeric.toFixed(decimals);
  const display = symbol ? `${symbol}${formatted}` : `${formatted} ${currency}`;
  return <span className={className} style={{ fontVariantNumeric: 'tabular-nums' }}>{display}</span>;
}

export default CurrencyAmount;
